import register from '../../../../global/js/registry';
export default register('m-pagination', () => import(/* webpackMode: "lazy" */ './m-pagination.controller'));
